import React from 'react';

import { Inbox } from 'lucide-react';

interface ListingStateProps {
  message: string;
  minHeight?: number;
  variant?: 'empty' | 'error';
}

export const ListingState: React.FC<ListingStateProps> = ({
  message,
  minHeight,
  variant = 'empty',
}) => {
  return (
    <div
      className="border border-neutral-200 dark:border-neutral-800 rounded-lg bg-white dark:bg-neutral-950 px-6 py-6 text-center text-sm text-neutral-600 dark:text-neutral-400 flex items-center justify-center"
      style={minHeight ? { minHeight } : undefined}
    >
      <div className="flex flex-col items-center gap-3">
        {variant === 'empty' && (
          <div className="flex flex-col items-center gap-2">
            <div className="p-3 bg-neutral-100 dark:bg-neutral-900 rounded-full">
              <Inbox className="w-6 h-6 text-neutral-400 dark:text-neutral-500" />
            </div>
          </div>
        )}
        <span>{message}</span>
      </div>
    </div>
  );
};

export default ListingState;
